import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['body']

  toggle() {
    if (this.element.open) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.element.open = true
    const body = this.bodyTarget
    const height = body.scrollHeight
    body.style.height = '0px'
    body.style.overflow = 'hidden'

    requestAnimationFrame(() => {
      body.style.transition = 'height 0.25s ease'
      body.style.height = `${height}px`
    })

    body.addEventListener('transitionend', () => {
      body.style.height = ''
      body.style.overflow = ''
      body.style.transition = ''
    }, { once: true })
  }

  close() {
    const body = this.bodyTarget
    body.style.height = `${body.scrollHeight}px`
    body.style.overflow = 'hidden'

    requestAnimationFrame(() => {
      body.style.transition = 'height 0.25s ease'
      body.style.height = '0px'
    })

    body.addEventListener('transitionend', () => {
      this.element.open = false
      body.style.height = ''
      body.style.overflow = ''
      body.style.transition = ''
    }, { once: true })
  }
}
